import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
// @ts-expect-error migrate upstream
import { getId } from 'dashboard-lib/public/dashboard/dashboard-schema';
import { DashboardFloatingAlertStore } from 'dashboard-components/shared/DashboardFloatingAlertStore';
import { track as dashboardTracker, EVENTS
// @ts-expect-error migrate upstream
} from 'dashboard-ui-components/tracking/DashboardUITracker';
// @ts-expect-error migrate upstream
import { refreshAll } from '../../../actions/DashboardActions';
import { useRefreshDashboard } from '../../../hooks/useRefreshDashboard';
import { jsx as _jsx } from "react/jsx-runtime";
const RefreshAllDashboardAction = ({
  dashboard,
  disabled
}) => {
  const dashboardId = getId(dashboard);
  const refreshDashboard = useRefreshDashboard(dashboardId);
  const handleClick = () => {
    dashboardTracker(EVENTS.refreshAll, {
      dashboardId
    });
    refreshDashboard(() => {
      refreshAll({
        dashboardId
      });
    });
    DashboardFloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.action.refreshAll.floatingAlert.message"
      }),
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.action.refreshAll.floatingAlert.title"
      }),
      type: 'success'
    });
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reportingActions.REFRESH_ALL.problem.LOADING"
    }),
    placement: "right",
    disabled: !disabled,
    children: /*#__PURE__*/_jsx(UIButton, {
      use: "link",
      onClick: handleClick,
      disabled: disabled,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.action.refreshAll.button"
      })
    })
  });
};
export default RefreshAllDashboardAction;